// @flow

export function getAutoMessagesLink(baseUrl: string) {
  return `${baseUrl}/auto_messages`;
}

export function getUploadedFilesLink(baseUrl: string) {
  return `${baseUrl}/uploaded_files`;
}
